module.exports = __webpack_public_path__ + "img/face_bg.33d8fd8b.png";